// extracted by mini-css-extract-plugin
module.exports = {"BooksTermsOfUse":"BooksTermsOfUse_BooksTermsOfUse__1u_6f","BooksTermsOfUse__Text":"BooksTermsOfUse_BooksTermsOfUse__Text__1nja-"};